import { object, string } from "yup";

const userIdSchema = object().shape({
  userId: string().ensure().trim().required("User ID is required"),
});

export default userIdSchema;
